import React, { useState, useEffect } from 'react';
import {setCookie} from '../../utils/functions';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { BsFillPatchCheckFill, BsCheck2, BsFillLightningChargeFill } from "react-icons/bs";
import { FaCheckCircle, FaMoneyBillWave } from "react-icons/fa";

export default function Products(props) {
  
  async function addToCart(product, period) {
    await setCookie('order', [{product, period}]);
    window.location.href = `https://portal.ultrastream.io/cart`;
  }

  return (
    props.products.filter(elem => ( elem.pricemonth === 0 && elem.stock > 0 ) || ( elem.pricemonth > 0 )).map((e, i)=>{
      return (
        <Col key={i} lg={12 / props.products.filter(elem => ( elem.pricemonth === 0 && elem.stock > 0 ) || ( elem.pricemonth > 0 )).length} md={6}>
          <div className="pricing-item">
            <div className="pricing-icon">
              <i className="bi bi-star"></i>
            </div>
            <h3>{e.product}</h3>
            <div className="price">
              <span className="currency">£</span>{props.period===1?e.pricemonth.toFixed(2):e.priceyear.toFixed(2)}<span className="period">/{props.period===1?'month':'year'}</span>
            </div>
            <p className="description">{e.quote}.</p>
            <ul className="features-list">
              <li>
                <BsCheck2 size={20} color={'#12a16b'} />
                {e.streams} Channels simultaneously
              </li>
              <li>
                <BsCheck2 size={20} color={'#12a16b'} />
                {e.recording} Hour Recording per stream 
              </li>
              <li>
                <BsCheck2 size={20} color={'#12a16b'} />
                {e.storage} Day's Recording Storage 
              </li>
              <li>
                {e.destinations===1 &&
                  <BsCheck2 size={20} color={'#12a16b'} />
                }
                Custom Destinations
              </li>
            </ul>
            {e.stock === 0 ?
              <button className="btn-pricing" disabled={true}>Out of Stock</button>
            :
              <button className="btn-pricing" onClick={()=>addToCart(e.id, props.period)}>Order Now</button>
            }
          </div>
        </Col>
      )
    })
  )
}